import _defineProperty from "/app/web/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/app/web/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["isMultiple", "isReadonly", "allowClear", "type", "placeholder"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { AppstoreOutlined } from '@ant-design/icons';
import { Avatar, Select, Space } from 'antd';
import { getCompanyStore } from 'core/modules/companies/company.store';
import { getMediaStore } from 'core/modules/media/media.store';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { sanitizeAll } from '../../utils/sanitize';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/** Renders a select to select companies. */
export var CompanySelect = function CompanySelect(_ref) {
  var isMultiple = _ref.isMultiple,
      isReadonly = _ref.isReadonly,
      allowClear = _ref.allowClear,
      type = _ref.type,
      placeholder = _ref.placeholder,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _getMediaStore = getMediaStore(),
      getCompanyMediaSrc = _getMediaStore.getCompanyMediaSrc;

  var _getCompanyStore = getCompanyStore(),
      allCompanies = _getCompanyStore.companies;

  var companies = useMemo(function () {
    if (!type) {
      return allCompanies;
    }

    return allCompanies.filter(function (company) {
      return company.type === type;
    });
  }, [allCompanies, type]);
  return /*#__PURE__*/_jsx(Select, _objectSpread(_objectSpread({}, props), {}, {
    mode: isMultiple ? 'multiple' : undefined,
    allowClear: allowClear,
    bordered: !isReadonly,
    disabled: isReadonly,
    showSearch: true,
    filterOption: function filterOption(input, option) {
      return sanitizeAll(option.title).includes(sanitizeAll(input));
    },
    placeholder: isReadonly ? undefined : placeholder !== null && placeholder !== void 0 ? placeholder : t('form.task.company.placeholder'),
    children: companies.map(function (company) {
      return /*#__PURE__*/_jsx(Select.Option, {
        value: company.id,
        title: "".concat(company.name, " ").concat(company.taxName, " ").concat(company.taxNumber),
        children: /*#__PURE__*/_jsxs(OptionContent, {
          size: "small",
          align: "center",
          children: [/*#__PURE__*/_jsx("span", {
            children: /*#__PURE__*/_jsx(Avatar, {
              size: 24,
              shape: "square",
              src: getCompanyMediaSrc(company.id),
              icon: /*#__PURE__*/_jsx(AppstoreOutlined, {})
            })
          }), /*#__PURE__*/_jsx("span", {
            className: "label",
            children: company.name
          })]
        })
      }, company.id);
    })
  }));
}; // Styles

var OptionContent = styled(Space).withConfig({
  displayName: "CompanySelect__OptionContent",
  componentId: "sc-1ej7awv-0"
})([".ant-space-item{height:20px;display:flex;align-items:center;}"]);